import { Text } from "@chakra-ui/layout";
import { CreditFacilityEventLayout } from "features/credit-facility/CreditFacilityEventLayout";
import { useCreditFacilityMergePrincipalTranchesSummaryTableListSuspense } from "gen/endpoints/credit-facility/credit-facility";
import { useFundFamilyEventRetrieveSuspense } from "gen/endpoints/fund-family-event/fund-family-event";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import { TextTableCellValue } from "gen/model/textTableCellValue";
import React from "react";
import { useTranslation } from "react-i18next";
import { PageWizardFormFooter } from "shared/components/layout/PageWizard";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { formatIsoDateToDisplay } from "shared/utils/DateUtils";

export const CreditFacilityMergeTranchesReview: React.FC = () => {
  const { fundFamilyId, fundFamilyEventId } = useRequiredStringParams();
  const { data: fundFamilyEvent } = useFundFamilyEventRetrieveSuspense(
    fundFamilyId,
    fundFamilyEventId,
  );
  const { t } = useTranslation(["creditFacility", "enums"]);
  return (
    <CreditFacilityEventLayout canEditEvent={false}>
      <Text mb="5px">
        {t("creditFacility:merge.review.description", {
          effectiveDate: formatIsoDateToDisplay(fundFamilyEvent.effective_date),
        })}
      </Text>
      <CreditFacilityMergeTranchesSummaryTables />
      <PageWizardFormFooter submitPermission={PermissionTypeEnum.approve} />
    </CreditFacilityEventLayout>
  );
};

export const CreditFacilityMergeTranchesSummaryTables: React.FC = () => {
  const { fundFamilyId, creditFacilityId, fundFamilyEventId } =
    useRequiredStringParams();
  const { data: loanSummaryTables } =
    useCreditFacilityMergePrincipalTranchesSummaryTableListSuspense(
      fundFamilyId,
      creditFacilityId,
      fundFamilyEventId,
    );

  return loanSummaryTables.map((loanSummaryTable, index) => (
    <TableBox isFullHeight={false} key={index}>
      <TableBoxHeader>
        <TableBoxTitle>
          {(
            loanSummaryTable.rows[0].cells["loan_type"]
              .value as TextTableCellValue
          ).text || ""}
        </TableBoxTitle>
        <DataTableBoxActions />
      </TableBoxHeader>
      <TableBoxBody>
        <DataTable data={loanSummaryTable} />
      </TableBoxBody>
    </TableBox>
  ));
};
